import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import PostForm from './PostForm';
import ReactRouter from 'react-router';
import CategoryPanel from '../categories/categoryPanel';
import {TagPanel} from '../';
import * as Api from 'api';
import * as Actions from 'actions';

class EditPostContainer extends React.Component {
	constructor(props) {
        super(props);
        this.displayName = 'EditPostContainer';
        this.handlePostRetrieval = this.handlePostRetrieval.bind(this);
        this.handleSaveError = this.handleSaveError.bind(this);
        this.createErrorBox = this.createErrorBox.bind(this);
        this.handlePostSave = this.handlePostSave.bind(this);
        this.handleSaveComplete = this.handleSaveComplete.bind(this);

        this.state = {
        	error : ""
        }
    }

    componentWillMount() {
        if(!this.props.hasPermission('/Post/Edit/')) {
            this.context.router.goBack();
        }
    }

    componentDidMount() {
      if(typeof this.props.connection.url !== 'undefined' && typeof this.props.params.id !== 'undefined') {
				Api.fetchPost(this.props.params.id).then(this.handlePostRetrieval)
					.catch(error => this.props.notify({title: 'Error retrieving post.', message:error.message}));
    	}
    }
    componentWillUnmount() {
        this.props.clearPost();
    }
    handlePostRetrieval(post) {
    	this.props.updatePost(post);
    	console.log("Post Retrieval Handled.");
    }
    handlePostSave(post) {
    	if(typeof this.props.connection.url !== 'undefined' && this.props.post._id !== 'undefined') {
    		console.log("Handle Post Save Called.");
    		var post = this.props.post;
				Api
					.updatePost(post)
					.then(response => this.props.notify({message:'Post saved!'},{type: 'success'}))
					.catch(error => this.props.notify({message:error.message, title: 'Error saving post.'}));
    	}


    }
    handleSaveComplete(data) {
    	this.props.history.push('/posts/');
    }
    handleSaveError(error) {
    	if(error.message) {
    		this.setState({ error : error.message });
    	}
    }
    clearError() {
    	this.setState({ error : null });
    }
    createErrorBox() {
		if(this.state.error) {
		return (
			<div className="alert alert-danger">
				<button type="button" onClick={this.clearError} className="close" data-dismiss="alert" aria-hidden="true">×</button>
				<strong>We encountered an error!</strong> {this.state.error}
			</div>
			)
		}
		else
			return "";
	}
    render() {
    	var errorBox = this.createErrorBox();
        return(
        	<section role="main" className="content-body">
				<header className="page-header">
					<h2>Posts</h2>

					<div className="right-wrapper pull-right">
						<ol className="breadcrumbs">
							<li>
								<a href="#/">
									<i className="fa fa-home"></i>
								</a>
							</li>
							<li><span>Posts</span></li>
							<li><span>Edit</span></li>
						</ol>

						<a className="sidebar-right-toggle" data-open="sidebar-right"><i className="fa fa-chevron-left"></i></a>
					</div>
				</header>
				{errorBox}

				<div className="col-md-8">
		        	<PostForm heading="Edit Post" handleSave={this.handlePostSave} />
	        	</div>
	        	<div className="col-md-4">
	        		<CategoryPanel />
                    <TagPanel />
	        	</div>
	        </section>
        );
    }
}

EditPostContainer.contextTypes = {
    router : PropTypes.object
}

var mapStateToProps = function(state) {
	return { connection : state.connection, post : state.post, categories : state.categories }
}

export default connect(mapStateToProps,Actions)(EditPostContainer);



// WEBPACK FOOTER //
// ./src/browser/components/posts/editPostContainer.js